import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { AUDITOR_ALLOWED_ROUTES, AUDITOR_HOME_ROUTE } from '@/config/constants';
import usePermissions from '@/hooks/use-permissions';

// Auditors may only reach the entity tabs and their detail/sub-routes. Everything else is redirected
// to their home (`/users`). UX-only defense-in-depth — the backend independently enforces reads.
const isAuditorAllowedRoute = (pathname: string) => {
  return AUDITOR_ALLOWED_ROUTES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`));
};
const useAuditorRouteGuard = () => {
  const router = useRouter();
  const {
    pathname
  } = router;
  const {
    isAuditor
  } = usePermissions();

  // `router` is intentionally omitted from deps — its identity churns across renders, and
  // including it would re-fire `replace` in a loop.
  useEffect(() => {
    if (isAuditor && !isAuditorAllowedRoute(pathname)) {
      router.replace(AUDITOR_HOME_ROUTE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuditor, pathname]);
};
export default useAuditorRouteGuard;